export const UPDATE_NAVIGATE_TO_MESSAGE_ID =
  'UPDATE_NAVIGATE_TO_MESSAGE_ID' as const

export const updateNavigateToMessageIdAction = (
  navigateToMessageId: number | null = null
) => ({
  type: UPDATE_NAVIGATE_TO_MESSAGE_ID,
  navigateToMessageId,
})
